import { render, staticRenderFns } from "./farmers_details.vue?vue&type=template&id=67c3f20a"
import script from "./farmers_details.vue?vue&type=script&lang=js"
export * from "./farmers_details.vue?vue&type=script&lang=js"
import style0 from "./farmers_details.vue?vue&type=style&index=0&id=67c3f20a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports